import { TagDetail } from '@pages/tag/_shared/TagDetail'

const IntelligentDetail = () => <TagDetail tagSourceType="intelligent" />

export default IntelligentDetail
